import { Box, Grid, Paper, Typography } from "@material-ui/core";
import { getDateFormats } from "app/dateFormats";
import { format } from "date-fns";
import FileImage from "images/FileCircle.svg";
import FolderImage from "images/FolderCircle.svg";
import React, { useEffect, useState } from "react";
import { isACCB, isDifc } from "Routes/Routes";
import { convertUTCToLocalMomentTime, getMeetingTimeFormatwithDateFirstAndComma, getMeetingTimeFormatwithDateFirstAndCommaDIFC, getMeetingTimeFormatwithTimeFirstAndComma, getMeetingTimeFormatwithTimeFirstAndCommaDIFC } from "slices/date";

export default function ActivityRow({
  bytesToSize,
  classes,
  handleClickOnFileFolderName,
  handleClickOnInvoice,
  item,
  profile,
}) {
  let isFolder = !item.is_for_file;
  const fileId = isACCB
    ? (item?.docs_file && typeof item.docs_file === "object"
      ? item.docs_file.id
      : item?.docs_file)
    : item?.file;
  const folderId = isACCB
    ? (item?.docs_folder && typeof item.docs_folder === "object"
      ? item.docs_folder.id
      : item?.docs_folder)
    : item?.folder;
  const disputeId = item?.dispute?.id;
  const file_or_folder_name =
    item.category === "payment"
      ? item.file_or_folder_name.split("_")[0]
      : item?.file_or_folder_name;
  const invoice_id =
    item.category === "payment" ? item.file_or_folder_name.split("_")[1] : null;
  const utc_date_time = item.date_time;

  const [formatted_local_time, setFormatted_local_time] = useState("");
  useEffect(() => {
    if (utc_date_time && item?.activity_name.includes("#")) {
      if (item.activity_name.includes("A hearing has been scheduled for")) {
        if (isDifc) {
          setFormatted_local_time(
            getMeetingTimeFormatwithDateFirstAndCommaDIFC(
              utc_date_time,
              profile?.profile?.timezone
            )
          );
        } else {
          setFormatted_local_time(
            getMeetingTimeFormatwithDateFirstAndComma(
              utc_date_time,
              profile?.profile?.timezone
            )
          );
        }
      } else if (item.activity_name.includes("Your hearing scheduled for")) {
        if (isDifc) {
          setFormatted_local_time(
            getMeetingTimeFormatwithTimeFirstAndCommaDIFC(
              utc_date_time,
              profile?.profile?.timezone
            )
          );
        } else {
          setFormatted_local_time(
            getMeetingTimeFormatwithTimeFirstAndComma(
              utc_date_time,
              profile?.profile?.timezone
            )
          );
        }
      } else {
        const local_date_time = convertUTCToLocalMomentTime(
          utc_date_time,
          profile?.profile?.timezone
        );
        setFormatted_local_time(local_date_time.format("hh:mm A"));
      }
    }
  }, [item, utc_date_time]);

  return (
    <React.Fragment key={item.id}>
      <Paper className={classes.activityPaper}>
        {(item.category === "files" ||
          (item.category === "payment" && item.file_or_folder_name)) && (
          <>
            <Grid container spacing={1} alignItems="center">
              <Grid item>
                <img
                  src={isFolder ? FolderImage : FileImage}
                  alt={isFolder ? "folder image" : "file image"}
                  style={
                    fileId || folderId || invoice_id
                      ? { height: "3.5rem", cursor: "pointer" }
                      : { height: "3.5rem" }
                  }
                  onClick={() => {
                    if (item.category === "files")
                      handleClickOnFileFolderName(
                        isFolder,
                        fileId,
                        folderId,
                        disputeId
                      );
                    else handleClickOnInvoice(invoice_id);
                  }}
                />
              </Grid>
              <Grid item sm={10} xs={9} style={{ minWidth: 0 }}>
                <Typography
                  className={classes.activityfileFolderName}
                  style={
                    !fileId && !folderId && !invoice_id
                      ? { textDecoration: "none", cursor: "default" }
                      : null
                  }
                  onClick={() => {
                    if (item.category === "files")
                      handleClickOnFileFolderName(
                        isFolder,
                        fileId,
                        folderId,
                        disputeId
                      );
                    else handleClickOnInvoice(invoice_id);
                  }}
                >
                  {file_or_folder_name}
                </Typography>
                {item.category === "files" && (
                  <Typography className={classes.activityTime}>
                    {bytesToSize(item?.size)}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Box height="0.7rem" />
          </>
        )}
        <Typography className={classes.activityUsername} display="inline">
          {item.uploaded_by
            ? `${item.uploaded_by.first_name} ${item.uploaded_by.last_name} `
            : ""}
        </Typography>
        <Typography className={classes.activityheading} display="inline">
          {utc_date_time && item?.activity_name.includes("#")
            ? item?.activity_name.replace("#", formatted_local_time)
            : item?.activity_name}
        </Typography>
        <Typography className={classes.activityTime}>
          {(isDifc || isACCB) &&
            (item?.activity_name.includes("You have a case hearing upcoming")
              ? `${format(new Date(item?.created), "dd/MM/yyyy")} - `
              : `${format(new Date(item?.created), "dd/MM/yyyy, h:mm a")} - `)}
          {!isDifc && !isACCB &&
            (item?.activity_name.includes("You have a case hearing upcoming")
              ? `${format(new Date(item?.created), getDateFormats().activityDate)} - `
              : `${format(new Date(item?.created), getDateFormats().activityDateTime)} - `)}
          {item?.dispute?.name}
          {isACCB && item?.dispute?.tiac_custom_dispute_id ? ` - ${item?.dispute?.tiac_custom_dispute_id}` : ""}
        </Typography>
      </Paper>
      <Box height="1rem" />
    </React.Fragment>
  );
}
